import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { identityConstants } from '../identity-constants';
import { MmTableDirective } from 'mm-web-core/table';
import { NzModalService } from 'ng-zorro-antd/modal';
import { RoleFormComponent } from '../role-form/role-form.component';
import { MmTranslateService } from 'mm-web-core/i18n';
import { RoleModel } from '../definition/role.model';
import { filter, tap } from 'rxjs/operators';
import { RoleApiService } from '../services/role-api.service';

@Component({
  selector: 'mm-role-management',
  templateUrl: './role-management.component.html',
  styleUrls: ['./role-management.component.scss']
})
export class RoleManagementComponent implements OnInit {

  form: FormGroup;
  constructor(fb: FormBuilder, private modalService: NzModalService, private mmTranslateService: MmTranslateService, private api: RoleApiService) {
    this.form = fb.group({

      displayName: fb.control(undefined)
    })

  }


  ngOnInit() {
    this.search();

  }

  search() {

    this.mmTable.search(this.form.value);
  }

  @ViewChild(MmTableDirective, { static: true })
  mmTable: MmTableDirective<any, any>;

  resolveKey(key: string) {
    return `${identityConstants.transalationGroup}.${key}`
  }
  async addRole() {

    const title = await this.mmTranslateService.get(this.resolveKey("AddRole")).toPromise();
    this.modalService.create({
      nzTitle: title,
      nzContent: RoleFormComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        usePermission: this.usePermission
      }
    }).afterClose.pipe(
      filter(_ => _),
      tap(() => {
        this.search()
      })
    ).subscribe();

  }

  async editRole(item: RoleModel) {
    // debugger;
    const title = await this.mmTranslateService.get(this.resolveKey("EditRole")).toPromise();
    this.modalService.create({
      nzTitle: title,
      nzContent: RoleFormComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        model: item,
        usePermission: this.usePermission
      }
    }).afterClose.pipe(
      filter(_ => _),
      tap(() => {
        this.search()
      })
    ).subscribe();
  }

  @Input()
  usePermission: boolean = true;

  async delete(model: any) {
    await this.api.delete(model.id).toPromise();
    this.mmTable.refresh();


  }

}

